import * as React from 'react'

export type SpinnerSize = 'sm' | 'md' | 'lg'
export type SpinnerTone = 'primary' | 'muted' | 'onDark'

interface SpinnerProps {
  size?: SpinnerSize
  tone?: SpinnerTone
  className?: string
}

const sizeClasses: Record<SpinnerSize, string> = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-12 w-12',
}

const toneClasses: Record<SpinnerTone, string> = {
  primary: 'text-indigo-600',
  muted: 'text-gray-400',
  onDark: 'text-white/70',
}

/** The one spinner in the app. Track and arc are the same currentColor at two opacities. */
export const Spinner: React.FC<SpinnerProps> = ({
  size = 'md',
  tone = 'primary',
  className = '',
}) => (
  <svg
    className={`animate-spin ${sizeClasses[size]} ${toneClasses[tone]} ${className}`}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    role="status"
    aria-hidden="true"
  >
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    />
  </svg>
)
